export default "__VITE_ASSET__DUYJaAjR__"